import React from "react";
import "./FeaturedLocations.css";
import { useConfigData } from "../hooks/useConfigData";

const PRIVACY = "privacy";
const TOS = "terms-and-conditions";

export const FooterWebsiteInfo = ({ i18n }) => {
  const configData = useConfigData();

  const _tosUrl = `/${
    i18n.i18n_current !== i18n.i18n_main ? i18n.i18n_current + "/" : ""
  }${TOS}`;
  const _tosTitle = configData[`terms_and_condition_${i18n.i18n_current}`];
  const _privacyUrl = `/${
    i18n.i18n_current !== i18n.i18n_main ? i18n.i18n_current + "/" : ""
  }${PRIVACY}`;
  const _privacyTitle = configData[`privacy_policy_${i18n.i18n_current}`];

  return (
    <div id="footer-links-website-info">
      <div>
        <a href={_privacyUrl} target="_blank">
          {_privacyTitle}
        </a>
      </div>

      <div>
        <a href={_tosUrl} target="_blank">
          {_tosTitle}
        </a>
      </div>
    </div>
  );
};
